/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AsatPowerMeterResultDto } from "./AsatPowerMeterResultDto";
import {
    AsatPowerMeterResultDtoFromJSON,
    AsatPowerMeterResultDtoFromJSONTyped,
    AsatPowerMeterResultDtoToJSON,
} from "./AsatPowerMeterResultDto";
import type { AsatConnectorResultDto } from "./AsatConnectorResultDto";
import {
    AsatConnectorResultDtoFromJSON,
    AsatConnectorResultDtoFromJSONTyped,
    AsatConnectorResultDtoToJSON,
} from "./AsatConnectorResultDto";

/**
 *
 * @export
 * @interface AsatDto
 */
export interface AsatDto {
    /**
     * CORE device identity (e.g. "TC0004").
     * @type {string}
     * @memberof AsatDto
     */
    deviceIdentity?: string;
    /**
     * Run-level status. InProgress is the only live state; the rest are terminal (the run has stopped).
     * @type {string}
     * @memberof AsatDto
     */
    status?: AsatDtoStatusEnum;
    /**
     * Why the run stopped (Manual or DurationLimit); null while running.
     * @type {string}
     * @memberof AsatDto
     */
    stoppedReason?: AsatDtoStoppedReasonEnum;
    /**
     * When the current run started (UTC).
     * @type {Date}
     * @memberof AsatDto
     */
    startedAtUtc?: Date;
    /**
     * When the run completed (UTC); null while running.
     * @type {Date}
     * @memberof AsatDto
     */
    completedAtUtc?: Date;
    /**
     * UniqueId of the CORE config frozen for this run; null if the run has never been started.
     * @type {string}
     * @memberof AsatDto
     */
    coreConfigurationId?: string;
    /**
     * Per-connector test results.
     * @type {Array<AsatConnectorResultDto>}
     * @memberof AsatDto
     */
    connectorResults?: Array<AsatConnectorResultDto>;
    /**
     * Per-power-meter test results.
     * @type {Array<AsatPowerMeterResultDto>}
     * @memberof AsatDto
     */
    powerMeterResults?: Array<AsatPowerMeterResultDto>;
}

/**
 * @export
 */
export const AsatDtoStatusEnum = {
    Unknown: "Unknown",
    Pending: "Pending",
    InProgress: "InProgress",
    Passed: "Passed",
    Failed: "Failed",
    Inconclusive: "Inconclusive",
} as const;
export type AsatDtoStatusEnum =
    (typeof AsatDtoStatusEnum)[keyof typeof AsatDtoStatusEnum];

/**
 * @export
 */
export const AsatDtoStoppedReasonEnum = {
    Unknown: "Unknown",
    Manual: "Manual",
    DurationLimit: "DurationLimit",
} as const;
export type AsatDtoStoppedReasonEnum =
    (typeof AsatDtoStoppedReasonEnum)[keyof typeof AsatDtoStoppedReasonEnum];

/**
 * Check if a given object implements the AsatDto interface.
 */
export function instanceOfAsatDto(value: object): value is AsatDto {
    return true;
}

export function AsatDtoFromJSON(json: any): AsatDto {
    return AsatDtoFromJSONTyped(json, false);
}

export function AsatDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): AsatDto {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        status: json["status"] == null ? undefined : json["status"],
        stoppedReason:
            json["stoppedReason"] == null ? undefined : json["stoppedReason"],
        startedAtUtc:
            json["startedAtUtc"] == null
                ? undefined
                : new Date(json["startedAtUtc"]),
        completedAtUtc:
            json["completedAtUtc"] == null
                ? undefined
                : new Date(json["completedAtUtc"]),
        coreConfigurationId:
            json["coreConfigurationId"] == null
                ? undefined
                : json["coreConfigurationId"],
        connectorResults:
            json["connectorResults"] == null
                ? undefined
                : (json["connectorResults"] as Array<any>).map(
                      AsatConnectorResultDtoFromJSON,
                  ),
        powerMeterResults:
            json["powerMeterResults"] == null
                ? undefined
                : (json["powerMeterResults"] as Array<any>).map(
                      AsatPowerMeterResultDtoFromJSON,
                  ),
    };
}

export function AsatDtoToJSON(value?: AsatDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        status: value["status"],
        stoppedReason: value["stoppedReason"],
        startedAtUtc:
            value["startedAtUtc"] == null
                ? undefined
                : value["startedAtUtc"].toISOString(),
        completedAtUtc:
            value["completedAtUtc"] == null
                ? undefined
                : value["completedAtUtc"].toISOString(),
        coreConfigurationId: value["coreConfigurationId"],
        connectorResults:
            value["connectorResults"] == null
                ? undefined
                : (value["connectorResults"] as Array<any>).map(
                      AsatConnectorResultDtoToJSON,
                  ),
        powerMeterResults:
            value["powerMeterResults"] == null
                ? undefined
                : (value["powerMeterResults"] as Array<any>).map(
                      AsatPowerMeterResultDtoToJSON,
                  ),
    };
}
